<template>
    <section class="team-mob"  v-if="loaded && ready" >


      <div class="container" :class="{'vis' :  offSet.last >= offsetIndex}"    >

        <div class="team-mob-header" v-if="lang == 0">
          <div>60 <span>+</span></div>
          <div>perspetivas <br> <span>únicas</span></div>

        </div>


    <div class="team-mob-header"  v-if="lang == 1">

      <div>60 <span>+</span></div>
      <div>unique <br> <span>prespectives</span></div>
        </div>


        <div class="list-people">
          <transition-group name="fade" >

              <div class="item-pair" v-for="(pair, index) in teamDataPair" :key="index" v-if=" index < pairVis ">

                <div class="item-people" v-for="(item, index) in pair" v-on:click="openPeople(item.id)">
                  <img :src="item.img" :alt="item.name">
                </div>

                <div class="text-people"  v-for="(item, index) in pair" :class="{'vis' : activePeople === item.id}" >
                  <div  class="text-people-content">

                    <div class="text-people-name">{{ item.name}}</div>
                    <div class="text-people-func">{{item.func[lang].name}}</div>
                    <!--div class="text-people-quote">{{item.quote}}</div-->
                    <p>&nbsp;</p>
                    <div class="text-people-text" v-html="item.text[lang].name"> </div>

                  </div>




                </div>
              </div>


          </transition-group>
          <transition name="fade">
          <div class="load-more" v-on:click="loadMore();" v-if="pairVis < teamDataPair.length">

            ver mais pessoas <span>+</span>
          </div>
          </transition>
        </div>







        </div>




      <!--div  v-if="itemActive != 99" class="ball-text-aux">{{newArr[itemActive].text[lang].name}}</div-->
    </section>
</template>

<script>




    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, PROJ, WP} from '../../main';
    import MediaType from "./MediaType";




   // import Masonry from "masonry-layout/masonry";



    export default {


        name: 'team-mob',
      components: { MediaType},
      props: ['actRoute', 'offSet', 'lang', 'isMobile' , 'offsetIndex', 'partners'],
        data() {
            return {
              loaded: false,
              ready: false,
              teamData: [],
              teamDataPair: [],
              activePeople: 999,
              pairVis: 2


            }
        },

      created() {
        const _this = this;

        //alert(this.$route.path.substring(9, this.$route.path.length))

        WP('team', function (response){

          _this.loaded = true;
          let tmp = [];


          for(let i = 0; i < response.length; i++){
            if(!response[i].partner){
              tmp.push(response[i])
            }

          }
          _this.teamData =  _this.getShuffledArr(tmp);

          let count = 0;
          let inc = 0;

          for(let i = 0; i < _this.teamData.length; i ++) {

            _this.teamData[i].id = i;

            if(inc === 0){
              _this.teamDataPair[count] = [];
            }

            if(inc < 2){
              _this.teamDataPair[count].push(_this.teamData[i])
              inc +=1;
            }

            if(inc === 2){
              inc = 0;
              count += 1;
            }






          }


          _this.init();

        });

      },
      mounted() {
        const _this = this;
        _this.ready = true;
        _this.init();



      },

      destroyed() {

      },

      methods: {





        init() {
          const _this = this;

          if(this.loaded && this.ready){



          }
        },


        getShuffledArr (arr){
          return [...arr].map( (_, i, arrCopy) => {
            var rand = i + ( Math.floor( Math.random() * (arrCopy.length - i) ) );
            [arrCopy[rand], arrCopy[i]] = [arrCopy[i], arrCopy[rand]]
            return arrCopy[i]
          })
        },

        openPeople(n){
          this.activePeople = n;


        },

        loadMore(){
          this.pairVis ++;
        }

























        },
    };

</script>


// WEBPACK FOOTER //
// src/components/Modules/TeamMob.vue